import React from 'react'

const BlogPage = () => {
  return (
    <>
    <h1 className="text-center item">Blogs</h1>
    <div class="card mb-3 blog bg-dark">
  <div class="row g-0">
    <div class="col-md-2">
      <img src="image/img/b-1.jpg" class="img-fluid rounded-start" alt="img"/>
    </div>
    <div class="col-md-8">
      <div class="card-body">
        <h5 class="card-title h4">Pearl Drop Earrings</h5>
        <p class="card-text">Pearl earrings usually contain a single pearl suspended from a thin wire or chain. These can be a piece of complementary jewellery alongside a prominent pearl necklace, giving your face a contrasting look. Per year rings are available in colours and decorative designs for you to choose from, making it easy to match the festival's mood.</p>
        <p class="card-text"><small class="text-muted">Last updated 3 mins ago</small></p>
      </div>
    </div>
    </div>
    </div>
    <div class="card mb-3 blog bg-dark">
  <div class="row g-0">
    <div class="col-md-2">
      <img src="image/img/b-2.jpg" class="img-fluid rounded-start" alt="img"/>
    </div>
    <div class="col-md-8">
      <div class="card-body">
        <h5 class="card-title h4">Pearl Choker Necklace</h5>
        <p class="card-text">The pearl necklace is perhaps the most popular type of pearl jewellery. Artisans can combine pearls of different shapes and colours to achieve many looks. Pearl chokers are often flaunted by celebrities and high rollers, giving them an automatic high-fashion appeal. Being one of the most versatile jewellery pieces, the pearl necklace must be in the jewellery set for festivals.</p>
        <p class="card-text"><small class="text-muted">Last updated 3 mins ago</small></p>
      </div>
    </div>
    </div>
    </div>
    <div class="card mb-3 blog bg-dark">
  <div class="row g-0">
    <div class="col-md-2">
      <img src="image/img/b-3.jpg" class="img-fluid rounded-start" alt="img"/>
    </div>
    <div class="col-md-8">
      <div class="card-body">
        <h5 class="card-title h4">Pearl Ring</h5>
        <p class="card-text">Pearl rings are all about elegance and quiet sophistication. Just like any other ring, pearl rings are designed to deliver a luxurious statement without standing out excessively. They may not be visible to everyone on your person, but once they are spotted, they instantly elevate how you are perceived on that occasion. Rings indicate that you are a person of commitment and courage.</p>
        <p class="card-text"><small class="text-muted">Last updated 3 mins ago</small></p>
      </div>
    </div>
    </div>
    </div>

    </>
  )
}

export default BlogPage
